// Mirror della validazione server-side in oniri-viewer-api/src/utils/ids.ts
// (`isValidResourceId(id, 'mdl')` → 'mdl_' + 16 hex chars).
// Drift risk: se backend estende lo schema (es. mdl_<32hex>), client rejecta
// id validi → bug. Smoke test 4.N validera' un id reale dallo staging.
export const MODEL_ID_REGEX = /^mdl_[a-f0-9]{16}$/;

// Cap difensivo per `?cam=` raw (validation reale del payload base64url +
// decode in 4.L Share feature). Charset base64url: A-Z a-z 0-9 - _.
export const CAMERA_ENCODED_MAX_LENGTH = 256;
const CAMERA_ENCODED_CHARSET = /^[A-Za-z0-9_-]+$/;

export function isValidCameraEncoded(value: string): boolean {
  return (
    value.length > 0 &&
    value.length <= CAMERA_ENCODED_MAX_LENGTH &&
    CAMERA_ENCODED_CHARSET.test(value)
  );
}

export type ParsedShareUrl =
  | { kind: 'main'; modelId: string; cameraEncoded: string | null }
  | { kind: 'embed'; modelId: string; cameraEncoded: string | null }
  | { kind: 'upload-fallback' }
  | { kind: 'invalid'; reason: 'no-id' | 'malformed-id' | 'unknown-route' };
